import * as React from "react";
import { Slot } from "@radix-ui/react-slot";

import { cn } from "../../lib/utils";

const FileUpload = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement> & {
    asChild?: boolean;
  }
>(({ className, asChild, ...props }, ref) => {
  const Comp = asChild ? Slot : "label";

  return (
    <Comp
      ref={ref}
      data-slot="file-upload"
      className={cn(
        "flex w-full cursor-pointer flex-col items-center gap-5 rounded-xl border border-dashed border-input p-8 text-center",
        "transition-colors duration-200 ease-out",
        "hover:bg-accent/50",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        className,
      )}
      {...props}
    />
  );
});
FileUpload.displayName = "FileUpload";

const FileUploadButton = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    asChild?: boolean;
  }
>(({ className, asChild, ...props }, ref) => {
  const Comp = asChild ? Slot : "div";

  return (
    <Comp
      ref={ref}
      data-slot="file-upload-button"
      className={cn(
        "inline-flex h-8 items-center justify-center gap-2.5 whitespace-nowrap rounded-lg bg-background px-2.5 text-sm text-muted-foreground",
        "cursor-pointer ring-1 ring-inset ring-input hover:bg-accent",
        className,
      )}
      {...props}
    />
  );
});
FileUploadButton.displayName = "FileUploadButton";

const FileUploadIcon = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    asChild?: boolean;
  }
>(({ className, asChild, ...props }, ref) => {
  const Comp = asChild ? Slot : "div";

  return (
    <Comp
      ref={ref}
      data-slot="file-upload-icon"
      className={cn("size-6 text-muted-foreground", className)}
      {...props}
    />
  );
});
FileUploadIcon.displayName = "FileUploadIcon";

export { FileUpload, FileUploadButton, FileUploadIcon };
